<template>
  <DataTable
    :value="value"
    :columns="columns"
    :row-wrapper="wrappers.row"
    :cell-wrapper="wrappers.cell"
    v-bind="$attrs"
    v-on="{ ...$listeners, 'update:selected': $ev => updateSelected($ev) }"
  >
    <template v-for="column in columns" v-slot:[column.id]="{ item }">
      <component :is="column.component" :key="column.id" :config="column" :item="item" v-bind="column" />
    </template>

    <template v-if="wrappers.expandedRow" #expanded-row="{ item }">
      <component
        v-for="(block, i) in [].concat(wrappers.expandedRow(item, filter))"
        :key="i"
        :is="block.component"
        v-bind="block.props"
      />
    </template>

    <template v-if="actions.length" #secondary-row-actions="{ item }">
      <template v-for="(action, i) in actions">
        <ButtonComponent
          :key="`action-${i}`"
          v-tooltip="runCallback(action.tooltip, item)"
          :label="action.label"
          :icon="action.icon"
          :disabled="runCallback(action.disabled, item)"
          @click="runCallback(action.action, item)"
        />
      </template>
    </template>
  </DataTable>
</template>

<script>
import DataTable from '@/components/DataTable'
import Fields from './Fields'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Array,
      default: () => [],
    },
    wrappers: {
      type: Object,
      default: () => ({}),
    },
    actions: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    columns() {
      const getComponent = v => {
        if (typeof v !== 'string') return v
        return Fields[v]
      }

      return this.config.map(e => ({ ...e, component: getComponent(e.component) }))
    },
  },
  methods: {
    runCallback(callback, item) {
      if (!callback) return
      return callback(item, this)
    },

    updateSelected(value) {
      this.$emit('update:selected', value)
    },
  },
  components: {
    DataTable,
    ...Fields,
    ProjectList: () => import('@/components/CustomFields/ProjectList'),
  },
}
</script>

<style lang="scss"></style>
